<template>
	<div class="reporting-page">

		<div class="row mx-0 mb-3 justify-content-center justify-content-lg-between">
			<div></div>
			<div class="d-flex align-items-center">
				<div ref="reviews_date_picker" class="dropdown-select date-picker"><i class="far fa-calendar f1 align-middle mr-2"></i>{{ dateRange }}</div>
				<strong class="mx-2">vs</strong>
				<div ref="reviews_compare_date_picker" class="dropdown-select date-picker"><i class="far fa-calendar f1 align-middle mr-2"></i>{{ comparisonDateRange }}</div>
			</div>
		</div>

		<div class="row mx-0 reporting-tabs" v-if="spark.state.currentTeam.type != 'bank'">
			<div class="col-md-4">
				<a href="#" @click.prevent="setActive('insights')" class="header-case">
					<div class="card" :class="{active: activeType == 'insights'}">
						<div class="card-body text-center">
							<i class="fa fa-lightbulb"></i>
							<span>{{ __('Sentiment') }}</span>
						</div>
					</div>
				</a>
			</div>
			<div class="col-md-4">
				<a href="#" @click.prevent="setActive('segments')" class="header-case">
					<div class="card" :class="{active: activeType == 'segments'}">
						<div class="card-body text-center">
							<i class="fa fa-globe"></i>
							<span>{{ __('Segments') }}</span>
						</div>
					</div>
				</a>
			</div>
			<div class="col-md-4">
				<a href="#" @click.prevent="setActive('responses')" class="header-case">
					<div class="card" :class="{active: activeType == 'responses'}">
						<div class="card-body text-center">
							<i class="far fa-comment"></i>
							<span>{{ __('Responses') }}</span>
						</div>
					</div>
				</a>
			</div>
		</div>

		<div class="row mx-0">
			<div class="col-md-12" v-if="activeType == 'insights'">
				<sentiment v-if="showNewSentiment" :teams="teams" :user="user" :params="params"></sentiment>
				<suggestions v-else :teams="teams" :user="user" :params="params"></suggestions>
			</div>
			<div class="col-md-12" v-if="activeType == 'segments'">
				<segments :teams="teams" :user="user" :params="params"></segments>
			</div>
			<div class="col-md-12" v-if="activeType == 'responses'">
				<responses :teams="teams" :user="user" :params="params"></responses>
			</div>
		</div>
	</div>
</template>
<script>
	import Sentiment from './Sentiment';
	export default {
		props: ['user', 'teams'],
		components: {
			Sentiment
		},
		data() {
			return {
				activeType: 'insights',
				params: {
					fromDate: moment().startOf('year').format('YYYY-MM-DD'),
					toDate: moment().format('YYYY-MM-DD'),
					comparisonFromDate: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
					comparisonToDate: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
				}
			}
		},
		computed: {
			showNewSentiment() {
				return true;
			},
			dateRange() {
				const from = moment().startOf('year').format('YYYY-MM-DD');
				const to = moment().format('YYYY-MM-DD');
				return this.params.fromDate == from && this.params.toDate == to ?
					"Year To Date" : `${this.params.fromDate} - ${this.params.toDate}`;
			},
			comparisonDateRange() {
				const from = moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD');
				const to = moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD');
				return this.params.comparisonFromDate == from && this.params.comparisonToDate == to  ?
					"Previous Year" : `${this.params.comparisonFromDate} - ${this.params.comparisonToDate}`;
			}
		},
		mounted() {
			const datePicker = this.$refs.reviews_date_picker

			$(datePicker).daterangepicker({
				ranges: this.getDefaultDateRanges(),
				autoApply: true,
				startDate: this.from_date,
				endDate: this.to_date,
				alwaysShowCalendars: true,
				opens: 'center',
				showDropdowns: true,
				minYear: 2000,
				maxYear: (new Date()).getFullYear() + 1
			}, this.updateDates)

			const compareDatePicker = this.$refs.reviews_compare_date_picker

			$(compareDatePicker).daterangepicker({
				ranges: this.getDefaultDateRanges(),
				autoApply: true,
				startDate: this.from_date,
				endDate: this.to_date,
				alwaysShowCalendars: true,
				opens: 'center',
				showDropdowns: true,
				minYear: 2000,
				maxYear: (new Date()).getFullYear() + 1
			}, this.updateCompareDates)

		},
		methods: {
			setActive(type) {
				this.activeType = type
			},
			updateDates(fromDate, toDate) {
				this.params.fromDate = fromDate.format('YYYY-MM-DD')
				this.params.toDate = toDate.format('YYYY-MM-DD')
			},
			updateCompareDates(fromDate, toDate) {
				this.params.comparisonFromDate = fromDate.format('YYYY-MM-DD')
				this.params.comparisonToDate = toDate.format('YYYY-MM-DD')
			}
		}
	}
</script>